import { render, staticRenderFns } from "./134.vue?vue&type=template&id=dbd2cac0&scoped=true&"
var script = {}
import style0 from "./134.vue?vue&type=style&index=0&id=dbd2cac0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd2cac0",
  null
  
)

export default component.exports